// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__RANC0","spin":"Spinner_spin__9-IZm","smallwidth":"Spinner_smallwidth__fsU46","fastSpin":"Spinner_fastSpin__z5BNV"};